module.exports = __webpack_public_path__ + "fonts/Gotham-XLightItalic.f1d50ca4.otf";